import javaRequest from '../utils/javaHttp'
// 列表
export function list(query) {
  return javaRequest({
    url: '/coupon/api/subscriptionPlan',
    method: 'GET',
    headers: {
      'Custom-Params': 'javaApi'
    },
    params: {
      ...query,
      fetch:'image'
    }
  })
}
// 详情
export function edit(query) {
  return javaRequest({
    url: '/coupon/api/subscriptionPlan/' + query.id+'?fetch=image',
    headers: {
      'Custom-Params': 'javaApi'
    },
    method: 'GET'
  })
}
// 新增
export function save(query) {
  return javaRequest({
    url: '/coupon/api/subscriptionPlan',
    headers: {
      'Custom-Params': 'javaApi'
    },
    method: 'POST',
    data: query
  })
}
// 更新
export function update(query) {
  return javaRequest({
    url: '/coupon/api/subscriptionPlan',
    headers: {
      'Custom-Params': 'javaApi'
    },
    method: 'PUT',
    data: query
  })
}
// 删除
export function del(query) {
  console.log(query);
  return javaRequest({
    url: '/coupon/api/subscriptionPlan',
    headers: {
      'Custom-Params': 'javaApi'
    },
    method: 'DELETE',
    params: {
      ids: query.id
    }
  })
}
export function enable (data) {
  return javaRequest({
    url:'/coupon/api/subscriptionPlan/enable/' + data.id,
    headers: {
      'Custom-Params': 'javaApi'
    },
    method: 'PUT'
  })
}
export function disable (query) {
  return javaRequest({
    url:'/coupon/api/subscriptionPlan/disable/'+query.id,
    headers: {
      'Custom-Params': 'javaApi'
    },
    method: 'PUT',
  })
}



// WEBPACK FOOTER //
// ./src/api/Combo.js